export const MAX_SEO_DESCRIPTION_LENGTH = 156;
